import { Autocomplete, Box, Button, ListItem, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AppModal from "../../../../components/AppModal/AppModal";
import { confirmDialog } from "../../../../components/ConfirmDialog/confirmDialog";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { addWorkerRole, GetAllWorkRole, removeWorkerRole } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { toast } from "react-toastify";

const WorkRole = ({profileInfo, getWorkerInfo}: any) => {
    const {state} = useAuth();
    const [workRoles, setWorkRoles] = useState<any>([]);
    const [selectedRole, setSelecetedRole] = useState<string[]>([]);
    const [isModalRoleOpen, setIsModalRoleOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [, setOpen] = useState(false);

    const handleCancelRole = () => {
        setIsModalRoleOpen(false);
    };

    const addWorkerRoleFunc = async () => {
        const response = await addWorkerRole(state.user?.token, {
            workerId: profileInfo.id,
            roleId: selectedRole
        });
        if(response) {
            setIsModalRoleOpen(false);
            toast.success('Work Role added successfully');
            getWorkerInfo();
        }
    };

    useEffect(() => {
        GetAllWorkRole(state.user?.token).then(setWorkRoles);
    }, []);

    const handleDelete = async (id: any) => {
        const response = await removeWorkerRole(state.user?.token, id);
        if(response) {
            getWorkerInfo();
        } else {
            toast.error('Something went wrong!')
        }
    }

    const rolesColumns: any = [
        {
            field: "roleName",
            headerName: "WorkRole",
            flex: 2,
            renderCell: (params: any) => (
                <div>{params.row.roleName}</div>
            ),
        },
        {
            field: "createdAt",
            headerName: "Added Date",
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.createdAt || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "delete",
            headerName: "Delete",
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => (
                <Button
                    variant="contained"
                    color="error"
                    style={{boxShadow: 'none'}}
                    onClick={() => {
                        setOpen(true);
                        confirmDialog({
                            title: `Are you sure you want to delete ${params.row.roleName}?`,
                            onOk: () => handleDelete(params.id),
                            okButtonProps: { danger: true },
                            okText: 'YES',
                            cancelText: 'NO',
                            centered: true
                        });
                    }}
                >
                    Delete
                </Button>
            )
        }
    ];

    const filteredRoles = profileInfo?.workerRoles
    ? profileInfo.workerRoles.filter((role: any) =>
        role?.roleName?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : [];
    
    return (
        <Box
           sx={{
               margin: "auto",
               padding: 4,
               background: "#fff",
               marginTop: 5,
               border: '1px solid rgb(236, 236, 236)'
           }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    mb: 2
                }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setIsModalRoleOpen(true)}
                    sx={{width: 170, boxShadow: "none"}}
                >
                    Add Work Role
                </Button>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <h2>Work Role</h2>
                <TextField
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    style={{width: 300}}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </Box>
            <Box>
                <DataGrid
                    rows={filteredRoles}
                    columns={rolesColumns}
                    style={{height: 474}}
                    sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15.5,
                        }
                    }}
                />
            </Box>
            <AppModal
                title={`Add Role for ${profileInfo?.name} ${profileInfo?.surname}`}
                onCancel={handleCancelRole}
                open={isModalRoleOpen}
                footer={[
                    <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                        <Button
                            variant="contained"
                            sx={{boxShadow: 'none', mb: 2}}
                            onClick={addWorkerRoleFunc}
                        >
                            Add Role
                        </Button>
                    </div>
                ]}>
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {xs: "1fr", md: "1fr"},
                        gap: 4
                    }}>
                    <Autocomplete
                        size="small"
                        options={workRoles}
                        onChange={(_, newValue) => setSelecetedRole(newValue.id)}
                        getOptionLabel={(option: any) => option.workRoleName || ""}
                        renderOption={(props, option) => (
                            <ListItem {...props} key={option.workRoleName}>
                              {option.workRoleName}
                            </ListItem>
                          )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Work Role"
                                placeholder="Select Work Role"
                            />
                        )}
                    />
                </Box>
            </AppModal>
        </Box>
    );
}

export default WorkRole;
